import styled from "styled-components";

export const BannerContainer = styled.div`
  margin-bottom: 10px;
`;
